let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c6u3S")).then(() => parcelRequire('3YJEd'));